import { render } from "./OutlineItemBlock.vue?vue&type=template&id=4fc7a966&ts=true"
import script from "./OutlineItemBlock.vue?vue&type=script&lang=ts"
export * from "./OutlineItemBlock.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__